import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LocalStorageKeys } from '../../enums';
import SearchCriteria from '../../models/search-criteria';

@Injectable({
  providedIn: 'root',
})
export class KipService {
  private kip = new BehaviorSubject<SearchCriteria>({ kip: '' });

  getKip = this.kip.asObservable();
  getKipFromLocalStorage(): SearchCriteria {
    const searchCriteria = localStorage.getItem(LocalStorageKeys.KIP);
    return JSON.parse(searchCriteria);
  }

  setKip(searchCriteria: SearchCriteria): void {
    this.kip.next(searchCriteria);
  }
  setKipInLocalStorage(searchCriteria: SearchCriteria): void {
    localStorage.setItem(LocalStorageKeys.KIP, JSON.stringify(searchCriteria));
  }

  removeKipFromLocalStorage(): void {
    localStorage.removeItem(LocalStorageKeys.KIP);
  }
}
